import React from 'react';
import Select, { SingleValue, StylesConfig } from 'react-select';
import { COUNTRY_OPTIONS, CountryOption } from '../constants/countries';

interface Props {
  value: string;
  onChange: (value: string) => void;
  borderColor?: string;
  required?: boolean;
}

const formatOptionLabel = (option: CountryOption) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <span>{option.flag}</span>
    <span>{option.label}</span>
  </div>
);

export const CountrySelect: React.FC<Props> = ({ value, onChange, borderColor = '#E5E7EB', required }) => {
  const selected = COUNTRY_OPTIONS.find((o) => o.value === value) || null;

  const handleChange = (option: SingleValue<CountryOption>) => {
    onChange(option ? option.value : '');
  };

  const styles: StylesConfig<CountryOption, false> = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? '#3B82F6' : borderColor,
      borderRadius: '0.5rem',
      padding: '2px 4px',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(59,130,246,0.3)' : 'none',
      '&:hover': { borderColor: state.isFocused ? '#3B82F6' : borderColor },
    }),
    menu: (base) => ({
      ...base,
      borderRadius: '0.5rem',
      zIndex: 50,
    }),
  };

  return (
    <Select<CountryOption>
      options={COUNTRY_OPTIONS}
      value={selected}
      onChange={handleChange}
      formatOptionLabel={formatOptionLabel}
      placeholder="Select a country..."
      isClearable
      isSearchable
      styles={styles}
      required={required}
    />
  );
};
